module.exports = __webpack_public_path__ + "img/documents-rej.57cb89e1.svg";